import React, { createContext, useContext, useState } from 'react';

const CertificateContext = createContext();

export const useCertificateDB = () => {
  const context = useContext(CertificateContext);
  if (!context) {
    throw new Error('useCertificateDB must be used within a CertificateProvider');
  }
  return context;
};

export const CertificateProvider = ({ children }) => {
  const [certificates, setCertificates] = useState([]);

  const addCertificate = (certificate) => {
    // Normalize hash field to camelCase and lowercase value
    const normalizedHash = (certificate.fileHash || certificate.file_hash || '')
      ?.toString()
      .trim()
      .toLowerCase();
    const cert = {
      ...certificate,
      ...(normalizedHash ? { fileHash: normalizedHash } : {})
    };
    setCertificates(prev => [...prev, cert]);
  };

  const findCertificateByHash = (hash) => {
    const target = (hash || '')?.toString().trim().toLowerCase();
    if (!target) return undefined;
    return certificates.find(cert => {
      const h = (cert.fileHash || cert.file_hash || '')?.toString().trim().toLowerCase();
      return !!h && h === target;
    });
  };

  const getAllCertificates = () => {
    return certificates;
  };

  const value = {
    certificates,
    addCertificate,
    findCertificateByHash,
    getAllCertificates
  };

  return (
    <CertificateContext.Provider value={value}>
      {children}
    </CertificateContext.Provider>
  );
};

export default CertificateContext;
